// Session state shared across pages. Because each page is a real document, the
// session is persisted in sessionStorage and reloaded on every page.

export interface Session {
  id: string;
  email: string;
  product: string; // product id (UUID)
  productName?: string; // display name, resolved from /me; may be absent on older sessions
  version: string | null;
  canViewDocs: boolean;
  canManageDocs: boolean;
  isOwner: boolean; // gates the owner-only admin/settings page
}

const KEY = "session";

export function saveSession(s: Session): void {
  sessionStorage.setItem(KEY, JSON.stringify(s));
}

export function loadSession(): Session | null {
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as Session;
  } catch {
    return null;
  }
}

export function clearSession(): void {
  sessionStorage.removeItem(KEY);
}

/** Return the active session, or redirect to the setup page and return null so
 *  the caller can simply `return`. */
export function requireSession(): Session | null {
  const s = loadSession();
  if (!s) location.replace("index.html");
  return s;
}
